// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Pager Component */
:host(ids-pager),
.ids-pager {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 38px;
  margin: 6px 4px;
  width: calc(100% - 16px);
}
:host(ids-pager) .pager-section,
.ids-pager .pager-section {
  box-sizing: border-box;
  flex-basis: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  text-align: center;
}
:host(ids-pager) .pager-section.start, :host(ids-pager) .pager-section.end,
.ids-pager .pager-section.start,
.ids-pager .pager-section.end {
  flex-grow: 1;
}
:host(ids-pager) .pager-section.start,
.ids-pager .pager-section.start {
  justify-content: flex-start;
  text-align: left;
}
:host(ids-pager) .pager-section.end,
.ids-pager .pager-section.end {
  justify-content: flex-end;
  text-align: right;
}

.ids-pager-dropdown {
  --ids-button-tertiary-font-weight: var(--ids-font-weight-normal);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-pager/ids-pager.scss"],"names":[],"mappings":"AAAA,wBAAA;AACA;;EAGE,mBAAA;EACA,aAAA;EACA,uBAAA;EAGA,YAAA;EACA,eAAA;EACA,wBAAA;AAFF;AAIE;;EACE,sBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AADJ;AAGI;;;EAEE,YAAA;AAAN;AAGI;;EACE,2BAAA;EACA,gBAAA;AAAN;AAGI;;EACE,yBAAA;EACA,iBAAA;AAAN;;AAKA;EACE,gEAAA;AAFF","sourcesContent":["/* Ids Pager Component */\n:host(ids-pager),\n.ids-pager {\n  // Alignment and Display\n  align-items: center;\n  display: flex;\n  justify-content: center;\n\n  // Sizing\n  height: 38px;\n  margin: 6px 4px;\n  width: calc(100% - 16px);\n\n  .pager-section {\n    box-sizing: border-box;\n    flex-basis: 0;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    white-space: nowrap;\n    text-align: center;\n\n    &.start,\n    &.end {\n      flex-grow: 1;\n    }\n\n    &.start {\n      justify-content: flex-start;\n      text-align: left;\n    }\n\n    &.end {\n      justify-content: flex-end;\n      text-align: right;\n    }\n  }\n}\n\n.ids-pager-dropdown {\n  --ids-button-tertiary-font-weight: var(--ids-font-weight-normal);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
